<template>
  <th v-if="isHeader">{{title}}</th>
  <td v-else @click="enableInput()">
    <v-text-field
      v-model="rowData.note"
      :disabled="inputDisabled"
      @blur="disableInput()"
      @keyup.enter="disableInput()"
    ></v-text-field>
  </td>
</template>

<script>
import axios from 'axios';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin.vue';

export default {
  name: 'box-note-edit-input',
  mixins: [VuetableFieldMixin],
  data() {
    return {
      currentBox: {},
      inputDisabled: true,
      apiUrl: window.api_url,
    };
  },
  methods: {
    enableInput() {
      this.currentBox = this.rowData;
      this.inputDisabled = false;
    },
    disableInput() {
      this.inputDisabled = true;
      this.editItem();
    },
    editItem() {
      const vm = this;

      if (this.currentBox !== null) {
        axios.patch(`${this.apiUrl}api/box/${this.currentBox.id}`, {
          note: this.currentBox.note,
        })
          .then((response) => {
            vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          })
          .catch((error) => {
            vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
          });
      }
    },
  },
};
</script>

<style scoped>
input:disabled:hover {
  cursor: pointer;
}
</style>
